<template>
	<div>
		<div class="cgqBox">
			<div class="cgqBoxTil">
				{{list.data.menuTitle}}
			</div>
			<div class="cgqBoxCen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div class="cgqBoxSp">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.urls" :key="index">
							<!-- <video :src="item"  :autoplay="true" muted loop></video> -->
							<img :src="item" v-if="!list.data.type||list.data.type==1"></img>
							<!-- <video :src="item" v-else :autoplay="true" muted loop></video> -->
							<template v-else>
								<template v-if="headerShow">
									<video :src="item" :autoplay="true" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
								</template>
								<template v-else>
									<video :src="item" muted loop webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
								</template>
							</template>
						</div>
					</div>
					<template v-if="!headerShow">
							<div class="swiper-hexin-prev"  :style="{
								left:`30px`,
								display:qhShow?activeIndex==0?'none':'block':'none'
							}" @click="prev()">
								<img src="@/assets/index/hxz.png" />
							</div>
							<div class="swiper-hexin-next" :style="{
								right:`30px`,
								display:qhShow?activeIndex==list.data.urls.length-1?'none':'block':'none'
							}" @click="next()">
								<img src="@/assets/index/hxy.png" />
							</div>
						</template>
				</div>
				<!-- <img src="@/assets/product/page6/sp.png" /> -->
				<!-- <video></video> -->
			</div>
			<div class="cgqBoxXiao">
				<div class="cgqBoxFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="cgqBoxForImg">
						<img :src="item.icon">
					</div>
					<div class="cgqBoxForName">
						{{item.title}}
					</div>
					<div class="cgqBoxForCen">
						<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				njgfList: [{
						img: require('@/assets/product/page6/scxryh.png'),
						name: '色彩渲染优化',
						cen: '- 根据饱和度、色调及明亮度 - 处理图像减小图像色彩误差'
					},
					{
						img: require('@/assets/product/page6/gsy.png'),
						name: '广色域',
						cen: '- 拓宽色域范围 - 将色彩真实还原'
					},
					{
						img: require('@/assets/product/page6/cdyyjsq.png'),
						name: '55/32寸超大医用监视器',
						cen: '- 流畅显示内镜影像，快响应、无拖影 - 视觉范围更广，防眩光、防散射'
					},
				],
				qhShow:true,
				activeIndex: 0,
			}
		},
		mounted() {
			let t = this
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				slidesPerView: 1,
				allowTouchMove: this.list.data.urls.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},
				
				},
			});
			this.$nextTick(function(){
				if(this.list.data.urls.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.urls.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.urls.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cgqBox {
		width: 1200px;
		margin: 0 auto;
		// padding-top: 153px;
		padding-bottom: 150px;

		.cgqBoxTil {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.cgqBoxCen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;

			>div {
				white-space: pre-line;
			}
		}

		.cgqBoxSp {
			width: 100%;
			height: 600px;
			margin-bottom: 38px;

			img {
				width: 100%;
				height: 600px;
			}

			video {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}
		}

		.cgqBoxXiao {
			display: flex;
			overflow-x: auto;

			.cgqBoxFor:not(:last-child) {
				margin-right: 40px;
			}

			.cgqBoxFor {
				// width: 300px;
				flex: 1;
				margin-bottom: 20px;

				.cgqBoxForImg {
					width: 70px;
					height: 70px;
					margin-bottom: 40px;

					img {
						width: 70px;
						height: 70px;
						object-fit: cover;
					}
				}

				.cgqBoxForName {
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					margin-bottom: 35px;
				}

				.cgqBoxForCen {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;

					>div {
						margin-top: 10px;
						white-space: pre-line;
						word-wrap: break-word;
						word-break: break-all;
					}
				}
			}
		}
	}

	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	@media screen and (max-width:1200px) {
		.cgqBox {
			width: 100% !important;
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.cgqBoxTil{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.cgqBoxCen{
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}
			.swiper-slide{
				width: 100% !important;
			}
			.cgqBoxSp {
				height: 300px !important;
				margin-bottom: 20px !important;
			
				img {
					height: 300px !important;
				}
			
				video {
					height: 300px !important;
				}
			}
			.cgqBoxXiao {
				flex-wrap: wrap;
				.cgqBoxFor:not(:last-child) {
					margin-right: 0px !important;
				}
				.cgqBoxFor:nth-of-type(2n-1) {
					margin-right: 20px !important;
				}
				.cgqBoxFor {
					min-width: calc(50% - 10px) !important;
					
					.cgqBoxForImg {
						width: 40px;
						height: 40px;
						margin-bottom: 20px !important;
			
						img {
							width: 40px !important;
							height: 40px !important;
							object-fit: cover;
						}
					}
			
					.cgqBoxForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}
			
					.cgqBoxForCen {
						font-size: 14px !important;
					}
				}
			}
			
			
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>